<template>
  <v-autocomplete v-model="form.share_template_id"
                  v-if="team.sharing_enabled && form.settings.can_be_shared"
                  clearable
                  label="Email Template"
                  placeholder=" "
                  hint="When a user shares this file with via email, use this email template instead of anything they wrote."
                  :items="filteredShareTemplates"
                  item-value="id"
                  item-text="name">
  </v-autocomplete>
</template>
<script>
import {mapGetters} from 'vuex';
import clone from 'lodash/clone';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'shareTemplates',
      'team',
      'user',
      'users',
    ]),

    filteredShareTemplates() {
      const themes = clone(this.shareTemplates);
      themes.unshift({id: '', name: 'None'});
      return themes;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchShareTemplates');
    },
  }
}
</script>
